// Suggests an organisation URL slug from its name, within the server slug rule
// (OrganisationSlug.cs, EIT-112): lowercase, [a-z0-9-], no leading/trailing hyphen,
// <=63 chars. Runs of out-of-charset characters collapse to a single hyphen — a
// derivation choice for tidy output, not a server constraint (the server regex accepts
// interior repeated hyphens). Best-effort only — the field stays editable, and an empty
// result (e.g. an all-non-Latin name) means the user must supply one.

// Letters NFKD does not decompose to ASCII, so fold them explicitly rather than drop them.
const TRANSLITERATE: Record<string, string> = {
  ß: 'ss', ø: 'o', Ø: 'o', æ: 'ae', Æ: 'ae', œ: 'oe', Œ: 'oe',
  þ: 'th', Þ: 'th', ð: 'd', Ð: 'd', ı: 'i', İ: 'i', ł: 'l', Ł: 'l',
};

export function deriveSlug(name: string): string {
  const folded = [...name].map((ch) => TRANSLITERATE[ch] ?? ch).join('');
  return folded
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '') // strip combining diacritical marks
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-') // any run of out-of-charset chars becomes one hyphen
    .replace(/^-|-$/g, '')
    .slice(0, 63)
    .replace(/-$/, ''); // drop a hyphen left exposed by truncation
}
